var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { CellMeasurer, CellMeasurerCache, InfiniteLoader, List } from 'react-virtualized';
import { OPTION_HEIGHT, OPTIONS_IN_DROPDOWN } from './constants';
import { OptionIcon, StyledDropdown, StyledLabel, StyledOption } from './styles';
import { Icon } from '../Icon';
// Workaround for react-virtualized's CellMeasure jest test
var createParent = process.env.NODE_ENV === 'test' ? function (_a) {
  var cache = _a.cache,
    _b = _a.invalidateCellSizeAfterRender,
    invalidateCellSizeAfterRender = _b === void 0 ? jest.fn() : _b;
  return {
    invalidateCellSizeAfterRender: invalidateCellSizeAfterRender,
    props: {
      deferredMeasurementCache: cache
    }
  };
} : null;
var SelectDropdown = /** @class */function (_super) {
  __extends(SelectDropdown, _super);
  function SelectDropdown(props) {
    var _this = _super.call(this, props) || this;
    _this.dropdownRef = React.createRef();
    _this.listRef = React.createRef();
    _this.cache = new CellMeasurerCache({
      defaultHeight: OPTION_HEIGHT,
      fixedWidth: true
    });
    _this.renderItem = _this.renderItem.bind(_this);
    _this.resetDropdownItemsCache = _this.resetDropdownItemsCache.bind(_this);
    return _this;
  }
  SelectDropdown.prototype.componentDidMount = function () {
    this.resetDropdownItemsCache();
    window.addEventListener('resize', this.resetDropdownItemsCache);
  };
  SelectDropdown.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.options !== prevProps.options) {
      this.resetDropdownItemsCache();
      if (this.listRef.current) {
        this.listRef.current.forceUpdateGrid();
      }
    }
  };
  SelectDropdown.prototype.componentWillUnmount = function () {
    window.removeEventListener('resize', this.resetDropdownItemsCache);
  };
  SelectDropdown.prototype.resetDropdownItemsCache = function () {
    this.cache.clearAll();
  };
  SelectDropdown.prototype.renderItem = function (_a) {
    var key = _a.key,
      index = _a.index,
      parent = _a.parent,
      style = _a.style;
    var _b = this.props,
      highlightIndex = _b.highlightIndex,
      onSelect = _b.onSelect,
      options = _b.options;
    var option = options[index];
    var elementParent = createParent ? createParent({
      cache: this.cache
    }) : parent;
    if (index >= options.length) return null;
    return _jsx(CellMeasurer, {
      cache: this.cache,
      columnIndex: 0,
      parent: elementParent,
      rowIndex: index,
      children: _jsxs(StyledOption, {
        highlighted: highlightIndex === index,
        onClick: function () {
          return option.disabled ? onSelect(-1) : onSelect(index);
        },
        disabled: option.disabled,
        style: style,
        children: [option.icon ? React.isValidElement(option.icon) ? option.icon : _jsx(OptionIcon, {
          children: _jsx(Icon, {
            size: 21,
            type: option.icon
          })
        }) : null, React.isValidElement(option.label) ? option.label : _jsx(StyledLabel, {
          title: option.label,
          inDropdown: true,
          children: option.label
        })]
      })
    }, key);
  };
  SelectDropdown.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      options = _a.options,
      open = _a.open,
      highlightIndex = _a.highlightIndex,
      width = _a.width,
      onSelect = _a.onSelect,
      visibleItems = _a.visibleItems,
      isSync = _a.isSync,
      props = __rest(_a, ["options", "open", "highlightIndex", "width", "onSelect", "visibleItems", "isSync"]);
    var dropdownVisibleItems = visibleItems || OPTIONS_IN_DROPDOWN;
    var dropdownHeight = OPTION_HEIGHT * dropdownVisibleItems;
    var rowCount = this.props.isSync ? options.length : this.props.remoteRowCount;
    if (rowCount < dropdownVisibleItems) {
      dropdownHeight = OPTION_HEIGHT * rowCount;
    }
    var dropdownList = function (listRef, onRowsRendered) {
      return _jsx(List, {
        ref: listRef,
        deferredMeasurementCache: _this.cache,
        width: width || 100,
        height: dropdownHeight,
        rowRenderer: _this.renderItem,
        rowHeight: _this.cache.rowHeight,
        rowCount: rowCount,
        onRowsRendered: onRowsRendered,
        scrollToIndex: highlightIndex
      });
    };
    return _jsx(StyledDropdown, __assign({
      open: open,
      ref: this.dropdownRef,
      visibleItems: dropdownVisibleItems
    }, props, {
      children: this.props.isSync ? dropdownList(this.listRef) : _jsx(InfiniteLoader, {
        minimumBatchSize: this.props.batchSize,
        isRowLoaded: this.props.isRowLoaded,
        loadMoreRows: this.props.loadMoreRows,
        rowCount: this.props.remoteRowCount,
        children: function (_a) {
          var registerChild = _a.registerChild,
            onRowsRendered = _a.onRowsRendered;
          return dropdownList(registerChild, onRowsRendered);
        }
      })
    }));
  };
  return SelectDropdown;
}(React.Component);
export { SelectDropdown };